import React from "react";

import "../styles/loader.css"

const Loader = () => {
    return <div style={{
        paddingTop: "350px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "white"
    }}>
        Taking you to the correct location...
        <div class="loadingOuter">
            <div class="loadingInner"></div>
        </div>
    </div>
}

export default Loader